<template>
  <v-row>
    <v-col md="4">
      <label for="">Visit Start Date</label>
      <date-picker
        @clearDate="startDate = null"
        :date="startDate"
        v-model="startDate"
      />
    </v-col>
    <v-col md="4">
      <label for="">Visit End Date</label>
      <date-picker
        @clearDate="endDate = null"
        :date="endDate"
        v-model="endDate"
      />
    </v-col>
    <v-col md="4">
      <br />
      <v-btn
        @click="dateGenerate"
        color="teal accent-4"
        depressed
        dark
        class="mb-1"
      >
        <v-icon left>mdi-magnify</v-icon>
        Search
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import DatePicker from "@/components/common/DatePicker";

export default {
  components: {
    DatePicker,
  },
  data: () => ({
    startDate: "",
    endDate: "",
  }),
  methods: {
    dateGenerate() {
      if (this.startDate && this.endDate) {
        this.$emit("generateDate", {
          startDate: this.startDate,
          endDate: this.endDate,
        });
      }
    },
  },
};
</script>

<style>
</style>